import api from "@api/index";

export async function isRegistrationCostValid({
  journeyType,
  businessModel,
  dealCarteGrise,
  registrationPostalCode,
}) {
  try {
    const {
      data: { carteGrise: carteGriseConfig },
    } = await api.getRegistrationCostStatus(journeyType, businessModel);

    if (carteGriseConfig?.enabled) {
      if (!dealCarteGrise) {
        return false;
      }

      const {
        data: {
          data: { registrationCost },
        },
      } = await api.getRegistrationCost(registrationPostalCode);

      if (
        dealCarteGrise.deliveryCost !== carteGriseConfig.deliveryCost ||
        dealCarteGrise.fixedTaxAmount !== carteGriseConfig.fixedTaxAmount ||
        dealCarteGrise.registrationCost !== registrationCost
      ) {
        return false;
      }
    }
  } catch (error) {
    console.error("Error fetching registration cost status:", error);
    throw error;
  }

  return true;
}
